namespace $ { export class $piterjs_intro extends $mol_view {

	/**
	 *  ```
	 *  title \PiterJS Вступление
	 *  ```
	 **/
	title() {
		return "PiterJS Вступление"
	}

	/**
	 *  ```
	 *  meetup $piterjs_meetup
	 *  ```
	 **/
	@ $mol_mem
	meetup() {
		return (( obj )=>{
			return obj
		})( new this.$.$piterjs_meetup(  ) )
	}

	/**
	 *  ```
	 *  page?val \
	 *  ```
	 **/
	@ $mol_mem
	page( val? : any , force? : $mol_mem_force ) {
		return ( val !== void 0 ) ? val : ""
	}

	/**
	 *  ```
	 *  pages *
	 *  	main <= Main
	 *  	about <= About
	 *  	projects <= Projects
	 *  	roles_org <= Roles_org
	 *  	roles_place <= Roles_place
	 *  	speakers <= Speakers
	 *  	place <= Place
	 *  	schedule <= Schedule
	 *  	profit <= Proft
	 *  	info <= Info
	 *  	follow <= Follow
	 *  	afterparty <= Afterparty
	 *  ```
	 **/
	pages() {
		return ({
			"main" :  this.Main() ,
			"about" :  this.About() ,
			"projects" :  this.Projects() ,
			"roles_org" :  this.Roles_org() ,
			"roles_place" :  this.Roles_place() ,
			"speakers" :  this.Speakers() ,
			"place" :  this.Place() ,
			"schedule" :  this.Schedule() ,
			"profit" :  this.Proft() ,
			"info" :  this.Info() ,
			"follow" :  this.Follow() ,
			"afterparty" :  this.Afterparty() ,
		})
	}

	/**
	 *  ```
	 *  Main $piterjs_intro_main meetup <= meetup
	 *  ```
	 **/
	@ $mol_mem
	Main() {
		return (( obj )=>{
			obj.meetup = () => this.meetup()
			return obj
		})( new this.$.$piterjs_intro_main(  ) )
	}

	/**
	 *  ```
	 *  About $piterjs_intro_page
	 *  	title \Кто мы?
	 *  	text \
	 *  		\Обсуждаем JS и всё, что в него компилируется
	 *  		\Проводим митапы в Питере каждый месяц с мая 2015
	 *  		\Без отпусков. Без перерывов. Без каникул.
	 *  		\Нам и этого стало мало...
	 *  ```
	 **/
	@ $mol_mem
	About() {
		return (( obj )=>{
			obj.title = () => "Кто мы?"
			obj.text = () => "Обсуждаем JS и всё, что в него компилируется\nПроводим митапы в Питере каждый месяц с мая 2015\nБез отпусков. Без перерывов. Без каникул.\nНам и этого стало мало..."
			return obj
		})( new this.$.$piterjs_intro_page(  ) )
	}

	/**
	 *  ```
	 *  Projects $piterjs_intro_page
	 *  	title \Наши проекты
	 *  	text \
	 *  		\PiterJS **Meetups** - митапы в Петербурге
	 *  		\PiterJS **Tour** - митапы в других городах
	 *  		\PiterJS **Conf** - конференции
	 *  		\PiterJS **Code+Learn** - воркшопы
	 *  ```
	 **/
	@ $mol_mem
	Projects() {
		return (( obj )=>{
			obj.title = () => "Наши проекты"
			obj.text = () => "PiterJS **Meetups** - митапы в Петербурге\nPiterJS **Tour** - митапы в других городах\nPiterJS **Conf** - конференции\nPiterJS **Code+Learn** - воркшопы"
			return obj
		})( new this.$.$piterjs_intro_page(  ) )
	}

	/**
	 *  ```
	 *  Roles_org $piterjs_intro_page
	 *  	title \Роли организаторов
	 *  	text \
	 *  		\Программный комитет
	 *  		\Фандрайзер 🔥
	 *  		\Видео-мастер
	 *  		\Дизайнер 🔥
	 *  		\Комьюнити-менеджер
	 *  		\Менеджер
	 *  ```
	 **/
	@ $mol_mem
	Roles_org() {
		return (( obj )=>{
			obj.title = () => "Роли организаторов"
			obj.text = () => "Программный комитет\nФандрайзер 🔥\nВидео-мастер\nДизайнер 🔥\nКомьюнити-менеджер\nМенеджер"
			return obj
		})( new this.$.$piterjs_intro_page(  ) )
	}

	/**
	 *  ```
	 *  Roles_place $piterjs_intro_page
	 *  	title \Роли на площадке
	 *  	text \
	 *  		\Техник
	 *  		\Видео-оператор
	 *  		\Фотограф 🔥
	 *  		\Ведущий трансляции
	 *  		\Ведущий мероприятия
	 *  ```
	 **/
	@ $mol_mem
	Roles_place() {
		return (( obj )=>{
			obj.title = () => "Роли на площадке"
			obj.text = () => "Техник\nВидео-оператор\nФотограф 🔥\nВедущий трансляции\nВедущий мероприятия"
			return obj
		})( new this.$.$piterjs_intro_page(  ) )
	}

	/**
	 *  ```
	 *  Speakers $piterjs_intro_page
	 *  	title \Докладчики
	 *  	text \
	 *  		\Нужны всегда
	 *  		\Даже если боишься
	 *  		\Поможем с темой
	 *  		\Поможем с подготовкой
	 *  		\Пиши на hi@piterjs.org
	 *  ```
	 **/
	@ $mol_mem
	Speakers() {
		return (( obj )=>{
			obj.title = () => "Докладчики"
			obj.text = () => "Нужны всегда\nДаже если боишься\nПоможем с темой\nПоможем с подготовкой\nПиши на hi@piterjs.org"
			return obj
		})( new this.$.$piterjs_intro_page(  ) )
	}

	/**
	 *  ```
	 *  Place $piterjs_intro_page
	 *  	title <= place_title
	 *  	text <= place_notes
	 *  ```
	 **/
	@ $mol_mem
	Place() {
		return (( obj )=>{
			obj.title = () => this.place_title()
			obj.text = () => this.place_notes()
			return obj
		})( new this.$.$piterjs_intro_page(  ) )
	}

	/**
	 *  ```
	 *  place_title \Мы в {place}
	 *  ```
	 **/
	place_title() {
		return "Мы в {place}"
	}

	/**
	 *  ```
	 *  place_notes \
	 *  ```
	 **/
	place_notes() {
		return ""
	}

	/**
	 *  ```
	 *  Schedule $piterjs_schedule
	 *  	meetup <= meetup
	 *  	title \Сегодня
	 *  ```
	 **/
	@ $mol_mem
	Schedule() {
		return (( obj )=>{
			obj.meetup = () => this.meetup()
			obj.title = () => "Сегодня"
			return obj
		})( new this.$.$piterjs_schedule(  ) )
	}

	/**
	 *  ```
	 *  Proft $piterjs_intro_page
	 *  	title \Бонусы
	 *  	text \
	 *  		\За лучшие вопросы - призы
	 *  		\Мы ведём трансляцию
	 *  		\И записываем видео
	 *  		\Улыбайтесь фотографу
	 *  ```
	 **/
	@ $mol_mem
	Proft() {
		return (( obj )=>{
			obj.title = () => "Бонусы"
			obj.text = () => "За лучшие вопросы - призы\nМы ведём трансляцию\nИ записываем видео\nУлыбайтесь фотографу"
			return obj
		})( new this.$.$piterjs_intro_page(  ) )
	}

	/**
	 *  ```
	 *  Info $piterjs_intro_page
	 *  	title \Твой вклад
	 *  	text \
	 *  		\patreon.com/piterjs
	 *  		\github.com/piterjs
	 *  		\hi@piterjs.org
	 *  ```
	 **/
	@ $mol_mem
	Info() {
		return (( obj )=>{
			obj.title = () => "Твой вклад"
			obj.text = () => "patreon.com/piterjs\ngithub.com/piterjs\nhi@piterjs.org"
			return obj
		})( new this.$.$piterjs_intro_page(  ) )
	}

	/**
	 *  ```
	 *  Follow $piterjs_intro_page
	 *  	title \Следите за новостями
	 *  	text \
	 *  		\medium.com/piterjs
	 *  		\twitter.com/gopiterjs
	 *  		\vk.com/piterjs
	 *  		\t.me/piterjs
	 *  		\youtube.com/piterjs
	 *  		\piterjs.org
	 *  ```
	 **/
	@ $mol_mem
	Follow() {
		return (( obj )=>{
			obj.title = () => "Следите за новостями"
			obj.text = () => "medium.com/piterjs\ntwitter.com/gopiterjs\nvk.com/piterjs\nt.me/piterjs\nyoutube.com/piterjs\npiterjs.org"
			return obj
		})( new this.$.$piterjs_intro_page(  ) )
	}

	/**
	 *  ```
	 *  Afterparty $piterjs_intro_page
	 *  	title \Го в бар!
	 *  	text <= afterparty
	 *  ```
	 **/
	@ $mol_mem
	Afterparty() {
		return (( obj )=>{
			obj.title = () => "Го в бар!"
			obj.text = () => this.afterparty()
			return obj
		})( new this.$.$piterjs_intro_page(  ) )
	}

	/**
	 *  ```
	 *  afterparty \
	 *  ```
	 **/
	afterparty() {
		return ""
	}

	/**
	 *  ```
	 *  sub / <= Screen
	 *  ```
	 **/
	sub() {
		return [this.Screen()] as readonly any[]
	}

	/**
	 *  ```
	 *  Screen $piterjs_screen
	 *  	place <= place
	 *  	content / <= Page
	 *  ```
	 **/
	@ $mol_mem
	Screen() {
		return (( obj )=>{
			obj.place = () => this.place()
			obj.content = () => [this.Page()] as readonly any[]
			return obj
		})( new this.$.$piterjs_screen(  ) )
	}

	/**
	 *  ```
	 *  place $piterjs_place
	 *  ```
	 **/
	@ $mol_mem
	place() {
		return (( obj )=>{
			return obj
		})( new this.$.$piterjs_place(  ) )
	}

	/**
	 *  ```
	 *  Page $mol_view
	 *  ```
	 **/
	@ $mol_mem
	Page() {
		return (( obj )=>{
			return obj
		})( new this.$.$mol_view(  ) )
	}

	/**
	 *  ```
	 *  plugins / <= Nav
	 *  ```
	 **/
	plugins() {
		return [this.Nav()] as readonly any[]
	}

	/**
	 *  ```
	 *  Nav $mol_nav
	 *  	keys_x <= page_ids
	 *  	keys_y <= page_ids
	 *  	current_x?val <=> page?val
	 *  	current_y?val <=> page?val
	 *  ```
	 **/
	@ $mol_mem
	Nav() {
		return (( obj )=>{
			obj.keys_x = () => this.page_ids()
			obj.keys_y = () => this.page_ids()
			obj.current_x = ( val? : any ) => this.page( val )
			obj.current_y = ( val? : any ) => this.page( val )
			return obj
		})( new this.$.$mol_nav(  ) )
	}

	/**
	 *  ```
	 *  page_ids /string
	 *  ```
	 **/
	page_ids() {
		return [] as readonly ( string )[]
	}

} }
